import { render, staticRenderFns } from "./AdminTOTPReset.vue?vue&type=template&id=28711c57"
import script from "./AdminTOTPReset.vue?vue&type=script&lang=js"
export * from "./AdminTOTPReset.vue?vue&type=script&lang=js"
import style0 from "./AdminTOTPReset.vue?vue&type=style&index=0&id=28711c57&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports